import { render, staticRenderFns } from "./NewCustomerPopup.vue?vue&type=template&id=d472c6a6&scoped=true&"
import script from "./NewCustomerPopup.vue?vue&type=script&lang=js&"
export * from "./NewCustomerPopup.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomerPopup.vue?vue&type=style&index=0&id=d472c6a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d472c6a6",
  null
  
)

export default component.exports